import React from 'react'
import injectSheet from 'react-jss'
import styles from './archived-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import ArchivedEntry from './archived-entry/archived-entry.container'

const ArchivedTable = ({ classes, invitations }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.invitedCell}>Invited on</HeadCell>
        <HeadCell className={classes.fromCell}>Invited by</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.center}>Conclusion</HeadCell>
      </tr>
    </thead>
    <tbody>
      {invitations.map(invitation => (
        <ArchivedEntry key={invitation.id} id={invitation.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(ArchivedTable)
